exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.green-input[data-v-847901b4] {\n  background-color: transparent;\n  box-shadow: none;\n  border: none;\n}\n", ""]);

// exports
